import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/data-connector/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { prepareValidationForAirtable } from './common/common_utils';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class AirtableDataSource extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSendRequset = async (values) => {
    const { userToken, dataSourceName } = values;
    const { actions, match, history } = this.props;
    const { projectId, version } = match.params;
    const headers = {
      Authorization: `Bearer ${userToken}`,
    };
    await actions.airtableWorkspaceList({ projectId, headers, version });
    if (this.props.dataConnector.airtableWorkspaces) {
      history.push(`/2.0/data-connector/${version}/v/${projectId}/airtable-workspaces`, {
        headers,
        dataSourceName,
      });
    }
  };
  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/2.0/collections/${version}/v/${projectId}/create`);
  };
  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />;
        </CommonPageComponent>
      );
    }

    const { dataConnector } = this.props;
    const { airtableWorkspaceListPending } = dataConnector;
    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Airtable" datasourceIconSvg="Airtable">
          <Formik
            initialValues={{
              dataSourceName: '',
              userToken: '',
            }}
            validationSchema={prepareValidationForAirtable}
            onSubmit={this.handleSendRequset}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={
                      'Enter name for the Data Source you want to create in drapcode.'
                    }
                  >
                    <Field
                      type="text"
                      name="dataSourceName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="dataSourceName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>

                <ParentCardNoHeader title="Airtable Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="User Token"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Airtable Token from your Airtable account section. This Key is necessary for your application to interact with the Airtable backend services. Never share it publicly.'
                      }
                    >
                      <Field
                        type="text"
                        name="userToken"
                        className="form-control form-control-sm"
                        placeholder="User Token"
                      />
                      <ErrorMessage name="userToken" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>

                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={isSubmitting || airtableWorkspaceListPending}
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader loading={airtableWorkspaceListPending}></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AirtableDataSource);
